import { render, staticRenderFns } from "./liff_portal.vue?vue&type=template&id=537ca97c&"
import script from "./liff_portal.vue?vue&type=script&lang=js&"
export * from "./liff_portal.vue?vue&type=script&lang=js&"
import style0 from "./liff_portal.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports